import type { Block, SeoMeta, TranslatableString } from '@geoic/shared';
import { createContentApi, type ContentRecord } from '../content-api.js';

export type PageRecord = ContentRecord & {
  slug: string;
  title: TranslatableString;
  isSystem: boolean;
  systemKey: string | null;
  blocks: Block[];
  parentId: string | null;
  seo: SeoMeta;
};

export const pagesApi = createContentApi<PageRecord>('/pages');
